import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_04_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-04-01",
    "name": "蜘蛛式热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["髋部下沉", "动态拉伸髋屈肌"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/9c4975997e93af82170fb6b5.mp4",
    "videoUrl": "/media/collections-20261008/videos/d0ce5064087d9a6a74721d34.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第4期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-04-02",
    "name": "手肘搭平板凳",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["胸椎旋转活动", "每侧保持30秒"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/fc1ff74493024d4347e8bbf8.mp4",
    "videoUrl": "/media/collections-20261008/videos/e7705592813ccd620f5a402c.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第4期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-04-03",
    "name": "坐姿绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "row",
    "tips": ["躯干保持稳定", "拉至小腹位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/2297c7e30390a0477510349f.mp4",
    "videoUrl": "/media/collections-20261008/videos/e522ca32783f85c971025be3.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
